import { render, staticRenderFns } from "./StageActivityNotes.vue?vue&type=template&id=51afc5e1&"
import script from "./StageActivityNotes.vue?vue&type=script&lang=ts&"
export * from "./StageActivityNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports